<template>
    <div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.savePlace.searchByName')"
                        solo
                        height="40"
                        @keyup.enter="getSavePlacePagination()">
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        @click="searchSavePlace()"
                        color="primary"
                        outlined
                        height="40">
                        {{ $vuetify.lang.t('$vuetify.savePlace.search') }}
                    </v-btn>
                </div>
            </div>
            <div>
                <v-btn
                    v-if="permissionCreate"
                    height="40px"
                    color="primary"
                    @click="openSavePlaceForm()">
                    + {{ $vuetify.lang.t('$vuetify.savePlace.create') }}
                </v-btn>
            </div>
        </div>

        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="total"
                :items="places"
                :loading="loading">
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action">
                        <v-icon
                            v-if="permissionUpdate"
                            class="mr-2"
                            @click.stop="openEditSavePlaceModal(item)">
                            edit
                        </v-icon>
                        <v-icon
                            v-if="permissionDelete"
                            class="mr-2"
                            @click.stop="openDeleteSavePlaceModal(item)">
                            delete
                        </v-icon>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>

        <save-place-form
            ref="savePlaceForm"
            :formValue="formValue"
            @success-created="getSavePlacePagination()"
            @success-updated="getSavePlacePagination()"
            @modal-closed="savePlaceFormModalIsClose()"
            :mode="mode"/>

        <delete-modal
            ref="modalSavePlace"
            @success-deleted="deleteSuccess()"
            :deleteForm="deleteForm"/>
    </div>
</template>

<script>
import SavePlaceForm from '@/components/modal/SavePlaceForm'
import DeleteModal from '@/components/modal/DeleteModal'
import permissionConstant from '@/constants/permissions.js'
export default {
    name: 'SavePlace',

    components: {
        SavePlaceForm,
        DeleteModal
    },

    data () {
        return {
            mode: '',
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            loading: false,
            total: 0,
            places: [],
            permissionCreate: true,
            permissionUpdate: true,
            permissionDelete: true,
            deleteForm: {
                header: '',
                content: '',
                path: ''
            },
            formValue: null
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.savePlace.namePlace'), value: 'name', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.savePlace.latitude'), value: 'lat', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.savePlace.longitude'), value: 'lon', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.savePlace.radian'), value: 'radian', width: '20%' },
                { text: '', value: 'action', width: '10%', sortable: false }
            ]
        }
    },

    methods: {
        async openDeleteSavePlaceModal (savePlace) {
            this.deleteForm.header = this.$vuetify.lang.t('$vuetify.savePlace.deletePlace')
            this.deleteForm.content = `${this.$vuetify.lang.t('$vuetify.savePlace.wantToDelete')} "${savePlace.name}"?`
            this.deleteForm.path = `check-in/delete/${savePlace.id}`
            this.$refs.modalSavePlace.dialog = true
        },

        async deleteSuccess () {
            await this.getSavePlacePagination()
            this.$notify({
                title: this.$vuetify.lang.t('$vuetify.savePlace.congratulation'),
                text: this.$vuetify.lang.t('$vuetify.savePlace.placeIsDeleted'),
                type: 'success'
            })
        },

        async searchSavePlace () {
            this.options.page = 1
            await this.getSavePlacePagination()
        },

        async getSavePlacePagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `check-in?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.places = res.data.data
                this.total = res.data.total
                this.loading = false
            }
        },

        openSavePlaceForm () {
            this.mode = 'create'
            this.$refs.savePlaceForm.openModal()
        },

        openEditSavePlaceModal (item) {
            this.mode = 'update'
            this.formValue = item
            this.$refs.savePlaceForm.openModal()
        },

        savePlaceFormModalIsClose () {
            this.mode = ''
        },

        checkPermission () {
            this.permissionCreate = this.$util.checkPermission(permissionConstant.blacklist.create)
            this.permissionUpdate = this.$util.checkPermission(permissionConstant.blacklist.update)
            this.permissionDelete = this.$util.checkPermission(permissionConstant.blacklist.delete)
        }
    },

    mounted () {
        this.checkPermission()
    },

    watch: {
        options: {
            async handler () {
                await this.getSavePlacePagination()
            },
            deep: true
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.getSavePlacePagination()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
    box-shadow: none !important;
    border: 1px solid #a8a8a8 !important;
}
</style>
